var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicWandWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.587 15.546l-1.29 1.261 2.296-2.244c.565-.55 1.407-.62 1.883-.157l21.241 20.736",
    stroke: "#FFF",
    strokeWidth: 1.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.587 15.546l-1.29 1.261c-.565.552-.637 1.375-.161 1.838L34.375 39.38",
    stroke: "#FFF",
    strokeWidth: 1.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.376 39.381l-.001-.001v.001z",
    stroke: "#231F20",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.818s-2.076 1.535-2.273 2.093c-.193.558.455 3.089.455 3.089s-1.57-2.088-2.112-2.278c-.538-.19-3.07.46-3.07.46s2.066-1.508 2.278-2.11c.212-.603-.46-3.072-.46-3.072s1.508 2.066 2.11 2.28c.603.21 3.072-.462 3.072-.462zM23.136 14s-3.06-3.138-4.043-3.34c-.985-.2-5.093 1.476-5.093 1.476s3.15-3.123 3.345-4.077C17.54 7.11 15.863 3 15.863 3s3.013 3.128 4.076 3.346C21.003 6.562 25 4.864 25 4.864s-3.128 3.012-3.345 4.075c-.217 1.064 1.48 5.061 1.48 5.061zm11.379 8s-2.142-2.298-2.843-2.457c-.701-.16-3.672.974-3.672.974s2.308-2.19 2.463-2.867c.154-.678-.98-3.65-.98-3.65s2.108 2.29 2.866 2.464c.76.172 3.651-.98 3.651-.98s-2.29 2.108-2.463 2.867c-.173.757.978 3.649.978 3.649zM21 25.903L24.903 22",
    stroke: "#FFF",
    strokeWidth: 1.41
  }))));
}
export default SvgMagicWandWhite;